import { render, staticRenderFns } from "./ArchiveEventList.vue?vue&type=template&id=d133a0de&"
import script from "./ArchiveEventList.vue?vue&type=script&lang=js&"
export * from "./ArchiveEventList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/staging.portal.letsreimagine.org/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d133a0de')) {
      api.createRecord('d133a0de', component.options)
    } else {
      api.reload('d133a0de', component.options)
    }
    module.hot.accept("./ArchiveEventList.vue?vue&type=template&id=d133a0de&", function () {
      api.rerender('d133a0de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/events/ArchiveEventList.vue"
export default component.exports